import { render } from "./ThankYouRegister.vue?vue&type=template&id=8a9fd6ce&scoped=true"
import script from "./ThankYouRegister.vue?vue&type=script&lang=js"
export * from "./ThankYouRegister.vue?vue&type=script&lang=js"

import "./ThankYouRegister.vue?vue&type=style&index=0&id=8a9fd6ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a9fd6ce"]])

export default __exports__